<script>
	import {USER} from '../store.js'
	import {createEventDispatcher,onMount} from 'svelte'
	const dispatch = createEventDispatcher()
	export let cliente

	let hoteles = ['','RDA','RDE']
	let historia = true
	let nuevo_comentario = ''

	function guardar(){
		let timestamp = (new Date).toISOString().slice(0,19).replace('T',' ')
		let user = $USER.username
		// { id, idcliente, idhotel, estado, lastupdate, comentario }
		let formateado = `###  ${user} ${timestamp} ###
${nuevo_comentario||'Actualizado'}

${cliente.comentario||''}
`
		let commCartera = {
							id: cliente.idcomment||0,
							idcliente: cliente.idcliente,
							idhotel: cliente.idhotel,
							comentario: formateado
						}

		dispatch('close',{cb:'save', item: commCartera })
	}

	function close(){
		dispatch('close',{cb:''})
	}

</script>

<div class="container position-absolute top-50 start-50 translate-middle border border-secondary rounded bg-light overflow-auto" style="height: 60%;z-index:2000;">
	<span class="btn btn-sm float-end btn-danger mt-1" on:click="{close}">&Cross;</span>
	<!-- <pre>{JSON.stringify(cliente,null,2)}</pre> -->
	<table class="table">
		<tbody>
			<tr>
				<td style="background-color:#{cliente.estado};">{cliente.idcliente}</td>
				<td style="background-color:#{cliente.estado};">{cliente.nombre}</td>
				<td style="background-color:#{cliente.estado};" class="hotel{cliente.idhotel}">{hoteles[cliente.idhotel||0]}</td>
				<td style="background-color:#{cliente.estado};" class="numero px-4">{(cliente.saldo_sub_3+cliente.saldo_sub_2+cliente.saldo_sub_1).toFixed(2)}</td>
				<td style="background-color:#{cliente.estado};" class="numero px-4">{cliente.saldo_add_0.toFixed(2)}</td>
				<td style="background-color:#{cliente.estado};" class="numero px-4">{cliente.saldosfp_add_0.toFixed(2)}</td>
				<td style="background-color:#{cliente.estado};" class="numero px-4">{cliente.saldo_add_1.toFixed(2)}</td>
				<td style="background-color:#{cliente.estado};" class="numero px-4">{cliente.saldosfp_add_1.toFixed(2)}</td>
				<td class="numero">{cliente.lastupdate || ''}</td>
			</tr>
			<tr>
				<td>Ejecutivo</td><td colspan=7>{cliente.ejecutivo}</td>
			</tr>
			<tr>
				<td colspan=9>
					<input type="radio" class="btn-check" name="historia" bind:group={historia} value={true} id="success-outlined" autocomplete="off" checked>
					<label class="btn btn-outline-dark btn-sm" for="success-outlined">Historia</label>

					<input type="radio" class="btn-check" name="historia" bind:group={historia} value={false} id="danger-outlined" autocomplete="off">
					<label class="btn btn-outline-dark btn-sm" for="danger-outlined"><i class="bi-plus"></i>Nuevo</label>
				</td>
			</tr>
			<tr>
				<td colspan=9>
					{#if historia}
							<textarea rows=7 class="form-control" readonly>{cliente.comentario}</textarea>
					{:else}
							<textarea rows=7 class="form-control" bind:value={nuevo_comentario} ></textarea>
					{/if}
				</td>
			</tr>
		</table>
		<div class="float-end pe-4">
			<button class="btn btn-dark" on:click={close}>Cancelar</button>
			<button class="btn btn-primary" on:click={guardar}>Actualizar</button>
		</div>
</div>
